import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import browser from '@openclassrooms/utils/browser';
import { getActiveLocale } from '@openclassrooms/translations';

import { jsonConfig } from 'Modules/dom';
import AppProviders from 'Modules/webapp/components/AppProviders';
import { sdk } from 'Modules/api';

import MainHeaderComponent from './variants/MainHeader';

export { default as SimpleHeader } from './variants/SimpleHeader';
export { default as BusinessContactHeader } from './variants/BusinessContactHeader';

const { App } = browser.window;

function getHeaderProps() {
  const config = jsonConfig('headerConfiguration');
  const isUserConnected = !!config.user;

  config.user = {
    ...config.user,
    moderationNotificationCount: browser.window.App.notifications.alerts || 0,
  };

  return {
    ...config,
    isConnected: isUserConnected,
  };
}

const logout = (logoutLink) => {
  sdk.authClient.setOauth2Tokens();
  document.location = logoutLink;
};

function initHeader() {
  if (App.scriptToLoad === App.script.WEBAPP || App.scriptToLoad === App.script.DASHBOARD) {
    return;
  }

  const headerElement = browser.document.getElementById('oc-header');

  if (!headerElement) {
    return;
  }

  const root = createRoot(headerElement);
  const headerProps = getHeaderProps();
  const content = (
    <MainHeaderComponent
      {...headerProps}
      isLegacy
      onLogOut={() => {
        logout(headerProps.user.link.logOut);
      }}
    />
  );
  root.render(
    <AppProviders productionPrefix="main-header">
      <Router basename={`/${getActiveLocale()}`}>{content}</Router>
      <Router basename="/forum/">{content}</Router>
    </AppProviders>
  );
}

export const MainHeader = (props) => {
  const headerProps = getHeaderProps();
  return (
    <MainHeaderComponent
      {...headerProps}
      {...props}
      onLogOut={() => {
        logout(headerProps.user.link.logOut);
      }}
    />
  );
};

export default initHeader;
